/**
 * Rendered by index.tsx instead of the app when initSiteConfig() could not
 * resolve the site on a real host (SCRUM-2384). Rendering the app anyway would
 * send the dev-fallback site id with every request, which the server answers
 * with a "No site found" error the editor cannot act on.
 *
 * Plain markup on purpose: the store, the router and the notification hub are
 * not mounted at this point.
 */
export const SITE_UNREACHABLE_TEXT =
  "The CMS server is not reachable right now. Reload the page in a minute.";

export default function SiteUnreachableNotice({
  onReload = () => window.location.reload(),
}: {
  onReload?: () => void;
}) {
  return (
    <div role="alert" style={{ maxWidth: 480, margin: "15vh auto", padding: 24, textAlign: "center" }}>
      <p>{SITE_UNREACHABLE_TEXT}</p>
      <button type="button" className="btn btn-primary" onClick={() => onReload()}>
        Reload
      </button>
    </div>
  );
}
